import FullSummaryService from '@/api/FullSummaryService.js'
import Vue from 'vue'
export const fullSummaryModule = {
  namespaced: true,
  state: () => ({
    fullSummaryData: {},
    fullSummaryLoadStatus: 'request'
  }),

  getters: {},
  mutations: {
    get(state, data) {
      if (data.length) state.fullSummaryData = data[0]
    },

    load_request(state, status) {
      state.finesLoadStatus = 'request'
    },
    load_success(state) {
      state.finesLoadStatus = 'success'
    },
    load_error(state) {
      state.finesLoadStatus = 'error'
    }
  },
  actions: {
    getFullSummaryAll({ commit }, params) {
      commit('load_request')

      FullSummaryService.getAll(params)
        .then((data) => {
          commit('get', data.data)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    }
  }
}
